function getAxiosResponse(err) {
    if (!err || typeof err !== 'object' || !('response' in err))
        return null;
    return err.response ?? null;
}
export function isAxiosStatus(err, status) {
    return getAxiosResponse(err)?.status === status;
}
export function parseValidationErrors(err) {
    const raw = getAxiosResponse(err)?.data?.validationErrors;
    if (!raw || typeof raw !== 'object')
        return {};
    const out = {};
    for (const [k, v] of Object.entries(raw)) {
        if (typeof v === 'string' && v.trim())
            out[k] = v;
    }
    return out;
}
export function parseOptionalFieldError(err, field) {
    const v = getAxiosResponse(err)?.data?.validationErrors?.[field];
    if (typeof v === 'string' && v.trim())
        return v;
    return null;
}
export function parseApiErrorMessage(err, fallback = 'Произошла ошибка') {
    const msg = getAxiosResponse(err)?.data?.message;
    if (typeof msg === 'string' && msg.trim())
        return msg;
    if (err instanceof Error &&
        err.message.trim() &&
        !err.message.startsWith('Request failed with status code')) {
        return err.message;
    }
    return fallback;
}
/**
 * Пауза до следующей попытки для ответа 429. Значение приходит и в теле, и в заголовке
 * `Retry-After`: заголовок читается как запасной вариант.
 */
export function parseRetryAfterSeconds(err, fallback) {
    const res = getAxiosResponse(err);
    const fromBody = res?.data?.retryAfterSeconds;
    if (typeof fromBody === 'number' && Number.isFinite(fromBody) && fromBody > 0) {
        return Math.ceil(fromBody);
    }
    const rawHeader = res?.headers?.['retry-after'] ?? res?.headers?.['Retry-After'];
    const fromHeader = Number(rawHeader);
    if (Number.isFinite(fromHeader) && fromHeader > 0)
        return Math.ceil(fromHeader);
    return fallback;
}
export function parseUnavailableProductsError(err) {
    const res = getAxiosResponse(err);
    if (!res || res.status !== 422)
        return null;
    const data = res.data;
    if (!data || data.code !== 'PRODUCTS_UNAVAILABLE_AT_RESTAURANT')
        return null;
    const ids = Array.isArray(data.unavailableProductIds)
        ? data.unavailableProductIds.filter((n) => typeof n === 'number')
        : [];
    return {
        message: typeof data.message === 'string' && data.message.trim()
            ? data.message
            : 'Часть товаров недоступна в выбранном ресторане',
        productIds: ids,
    };
}
